import { api } from '@verifime/api-definition';

export const confirmUserCredentialStatus = async () => {
  return api
    .patchV1usermecredentialSetupStatus({
      withCredentials: true,
    })
    .catch((err) => {
      console.error(err);
    });
};
